<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask :id="maskIds.topLeft" fill="#fff">
      <rect x="2" y="2" width="8.889" height="11.111" rx="1" />
    </mask>
    <rect x="2" y="2" width="8.889" height="11.111" rx="1" :stroke="color" stroke-width="3" :mask="maskUrls.topLeft" />
    <mask :id="maskIds.bottomLeft" fill="#fff">
      <rect x="2" y="15.333" width="8.889" height="6.667" rx="1" />
    </mask>
    <rect
      x="2"
      y="15.333"
      width="8.889"
      height="6.667"
      rx="1"
      :stroke="color"
      stroke-width="3"
      :mask="maskUrls.bottomLeft"
    />
    <mask :id="maskIds.topRight" fill="#fff">
      <rect x="13.111" y="2" width="8.889" height="6.667" rx="1" />
    </mask>
    <rect
      x="13.111"
      y="2"
      width="8.889"
      height="6.667"
      rx="1"
      :stroke="color"
      stroke-width="3"
      :mask="maskUrls.topRight"
    />
    <mask :id="maskIds.bottomRight" fill="#fff">
      <rect x="13.111" y="10.889" width="8.889" height="11.111" rx="1" />
    </mask>
    <rect
      x="13.111"
      y="10.889"
      width="8.889"
      height="11.111"
      rx="1"
      :stroke="color"
      stroke-width="3"
      :mask="maskUrls.bottomRight"
    />
  </svg>
</template>

<script lang="ts" setup>
import { getCurrentInstance } from 'vue';

withDefaults(defineProps<{ color?: string }>(), {
  color: 'currentColor',
});

const instanceUid = getCurrentInstance()?.uid ?? 0;
const maskIdPrefix = `product-icon-${instanceUid}`;

const maskIds = {
  topLeft: `${maskIdPrefix}-top-left`,
  bottomLeft: `${maskIdPrefix}-bottom-left`,
  topRight: `${maskIdPrefix}-top-right`,
  bottomRight: `${maskIdPrefix}-bottom-right`,
};

const maskUrls = {
  topLeft: `url(#${maskIds.topLeft})`,
  bottomLeft: `url(#${maskIds.bottomLeft})`,
  topRight: `url(#${maskIds.topRight})`,
  bottomRight: `url(#${maskIds.bottomRight})`,
};
</script>
